import { useContext, useEffect, useState } from "react";
import ModalBase from "./ModalBase";
import { INewFeeModal } from "../../interfaces/modal";
import { Grid, Typography } from "@mui/material";
import { INewFeeFormValues, TFee } from "../../interfaces/configuration";
import NewFeeForm from "../forms/NewFeeForm";
import ConfirmChangesButtons from "../configuration/ConfirmChangesButtons";
import { POST } from "../../utils/constants";
import { validateInputs } from "../../utils/inputValidations";
import { UserContext } from "../../contexts/userContext";
import { fetchData } from "../../utils/dataProvider";
import { IAcceptedIntegration } from "../../interfaces/integrations";
import {
  parseFeeToFormValues,
  formValidations,
  parseBodyForFeeRuleCreation,
} from "../../utils/fees";
import { useDebounce } from "../../customHooks/useDebounce";

const FeeModal = ({
  open,
  setOpen,
  action,
  selectedFee,
  setSelectedFee,
  handleGetFees,
}: INewFeeModal) => {
  const { marketplaceIntegrations, carriers } = useContext(UserContext);
  // getting merchant IDS integrations
  const merchantsAcceptedIntegrationsIds =
    marketplaceIntegrations?.integrations?.reduce(
      (accum: number[], { merchantId }: IAcceptedIntegration) =>
        accum.concat(merchantId),
      [] as number[]
    ) ?? [];
  const defaultValuesState = parseFeeToFormValues(
    selectedFee as TFee,
    merchantsAcceptedIntegrationsIds,
    carriers
  );
  const [values, setValues] = useState<INewFeeFormValues>(defaultValuesState);
  const [errors, setErrors] = useState<{ [key: string]: string[] }>({});
  const [loading, setLoading] = useState<boolean>(false);

  const closeAndResetModalInfo = () => {
    setOpen(false);
    setErrors({});
    setSelectedFee(null);
  };

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const formErrors = validateInputs(values, formValidations);
      setErrors(formErrors);

      if (Object.keys(formErrors).length === 0) {
        values.id = selectedFee?.id;
        const parsedBody = parseBodyForFeeRuleCreation(values);
        await fetchData({
          url: "/customization_fees",
          method: POST,
          body: parsedBody,
        });
        closeAndResetModalInfo();
        handleGetFees();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const { setSubmitting: setSubmittingConfirmFee } = useDebounce(handleConfirm);

  const titleByAction: { [key: string]: string } = {
    create: "Añadir regla",
    edit: "Editar regla",
  };

  useEffect(() => {
    setValues(defaultValuesState);
  }, [selectedFee]);

  return (
    <ModalBase open={open} handleClose={closeAndResetModalInfo} maxWidth="md">
      <Grid container pt={1.25}>
        <Typography className="f-s-24" mb={2}>
          {titleByAction[action]}
        </Typography>
        <NewFeeForm
          {...{ values, setValues, errors, defaultValues: defaultValuesState }}
        />
        <ConfirmChangesButtons
          size={6}
          cancelButtonText="Volver"
          handleConfirm={() => setSubmittingConfirmFee(true)}
          handleCancel={closeAndResetModalInfo}
          loadingConfirmButton={loading}
        />
      </Grid>
    </ModalBase>
  );
};

export default FeeModal;
